import * as React from 'react'
import { Block } from '../Layout/Block'
import { Text } from '../Text'
import { Switch } from '.'
import { styled } from '$utils/theme'
import { css } from 'styled-components'
import { rem } from 'polished'

export interface Props {
  className?: string
  title?: string
  onBlur?: any
  isChecked?: any
  name?: string
  visible?: boolean
  titleSize?: string
  onClick?: () => void
}

interface State {
  isToggled?: boolean
}

const TitleBlock = styled(Text)`
  display: inline-flex;
  flex-grow: 1;
  font-weight: 500;
  margin-right: ${p => rem(p.theme.sizes.base)};
`
const StyledBlock = styled(Block).attrs({})<Props>`
  position: absolute;
  opacity: 0;
  z-index: -1;
  ${p =>
    p.visible &&
    css`
      position: static;
      opacity: 1;
      transition: opacity 0.4s linear;
    `};
`

export class SwitchBlock extends React.Component<Props, State> {
  state = {
    isToggled: this.props.isChecked(this.props.name),
  }
  private toggleIsOpen = () => {
    this.setState({ isToggled: !this.state.isToggled })
  }
  render() {
    const { name, title, titleSize, isChecked, children, onBlur, ...props } = this.props
    return (
      <>
        <Block flex>
          <TitleBlock {...(titleSize ? titleSize : 'medium')} marginRight="small">
            {title}
          </TitleBlock>
          <Switch
            name={name}
            onClick={this.toggleIsOpen && props.onClick}
            isChecked={isChecked}
            onBlur={onBlur}
            {...props}
          />
        </Block>
        <StyledBlock visible={this.state.isToggled} marginTop="small">
          {children}
        </StyledBlock>
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/components/Switch/SwitchBlock.tsx